import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Scissors, Ruler, Drill, Bath, ChefHat, Truck } from "lucide-react";
import { services } from "../../mock";

const icons = [Scissors, Ruler, Drill, Bath, ChefHat, Truck];

export default function Services() {
  return (
    <section id="services" className="relative bg-brand-cream py-20 sm:py-28">
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal flex flex-col gap-3">
          <span className="kicker text-brand-teal">01 / What we do</span>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight max-w-xl">
              Concrete cutting, done properly.
            </h2>
            <p className="max-w-md text-brand-ink/60 leading-relaxed">
              Every job is measured, marked and cut on-site with the right blade for the
              slab. If it&rsquo;s concrete and needs a clean line, we handle it.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3">
          {services.map((s, i) => {
            const Icon = icons[i];
            return (
              <Link
                key={s.title}
                to="/quote"
                className="reveal group relative flex flex-col justify-between rounded-2xl border-2 border-brand-ink/15 bg-brand-stone/60 p-5 sm:p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-brand-teal hover:bg-white hover:shadow-xl hover:shadow-black/5"
                style={{ transitionDelay: `${(i % 3) * 60}ms` }}
              >
                <div>
                  <div className="flex items-start justify-between">
                    <span className="flex h-11 w-11 sm:h-12 sm:w-12 items-center justify-center rounded-xl bg-brand-tealsoft text-brand-tealdark transition-colors duration-300 group-hover:bg-brand-teal group-hover:text-white">
                      <Icon className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={1.8} />
                    </span>
                    <span className="font-display text-sm font-semibold text-brand-ink/25">{s.num}</span>
                  </div>
                  {s.tag ? (
                    <span className="mt-4 inline-block rounded-full bg-brand-tealsoft px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-brand-tealdark">
                      {s.tag}
                    </span>
                  ) : null}
                  <h3 className="mt-4 font-display text-base sm:text-xl font-semibold leading-tight">{s.title}</h3>
                  <p className="mt-2 sm:mt-3 text-[13px] sm:text-sm leading-relaxed text-brand-ink/60">{s.blurb}</p>
                </div>
                <span className="mt-5 sm:mt-7 inline-flex items-center gap-1.5 text-[13px] sm:text-sm font-semibold text-brand-teal">
                  Get a quote
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            );
          })}
        </div>

        <div className="reveal mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <p className="text-sm text-brand-ink/50">Every quote is free, no obligation.</p>
          <Link to="/quote" className="inline-flex items-center gap-2 rounded-full bg-brand-teal px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-brand-tealdark">
            Free Quote
          </Link>
        </div>
      </div>
    </section>
  );
}
